export default __webpack_public_path__ + "static/media/Vambrace of Red Ruin (nm).8e9b4395.jpg";